import { StateRecord } from '../types/location';

export const USStates: StateRecord[] = [
  { value: 'Alabama', label: 'Alabama', abbreviation: 'AL' },
  { value: 'Alaska', label: 'Alaska', abbreviation: 'AK' },
  { value: 'Arizona', label: 'Arizona', abbreviation: 'AZ' },
  { value: 'Arkansas', label: 'Arkansas', abbreviation: 'AR' },
  { value: 'California', label: 'California', abbreviation: 'CA' },
  { value: 'Colorado', label: 'Colorado', abbreviation: 'CO' },
  { value: 'Connecticut', label: 'Connecticut', abbreviation: 'CT' },
  { value: 'Delaware', label: 'Delaware', abbreviation: 'DE' },
  { value: 'Florida', label: 'Florida', abbreviation: 'FL' },
  { value: 'Georgia', label: 'Georgia', abbreviation: 'GA' },
  { value: 'Hawaii', label: 'Hawaii', abbreviation: 'HI' },
  { value: 'Idaho', label: 'Idaho', abbreviation: 'ID' },
  { value: 'Illinois', label: 'Illinois', abbreviation: 'IL' },
  { value: 'Indiana', label: 'Indiana', abbreviation: 'IN' },
  { value: 'Iowa', label: 'Iowa', abbreviation: 'IA' },
  { value: 'Kansas', label: 'Kansas', abbreviation: 'KS' },
  { value: 'Kentucky', label: 'Kentucky', abbreviation: 'KY' },
  { value: 'Louisiana', label: 'Louisiana', abbreviation: 'LA' },
  { value: 'Maine', label: 'Maine', abbreviation: 'ME' },
  { value: 'Maryland', label: 'Maryland', abbreviation: 'MD' },
  { value: 'Massachusetts', label: 'Massachusetts', abbreviation: 'MA' },
  { value: 'Michigan', label: 'Michigan', abbreviation: 'MI' },
  { value: 'Minnesota', label: 'Minnesota', abbreviation: 'MN' },
  { value: 'Mississippi', label: 'Mississippi', abbreviation: 'MS' },
  { value: 'Missouri', label: 'Missouri', abbreviation: 'MO' },
  { value: 'Montana', label: 'Montana', abbreviation: 'MT' },
  { value: 'Nebraska', label: 'Nebraska', abbreviation: 'NE' },
  { value: 'Nevada', label: 'Nevada', abbreviation: 'NV' },
  { value: 'New Hampshire', label: 'New Hampshire', abbreviation: 'NH' },
  { value: 'New Jersey', label: 'New Jersey', abbreviation: 'NJ' },
  { value: 'New Mexico', label: 'New Mexico', abbreviation: 'NM' },
  { value: 'New York', label: 'New York', abbreviation: 'NY' },
  { value: 'North Carolina', label: 'North Carolina', abbreviation: 'NC' },
  { value: 'North Dakota', label: 'North Dakota', abbreviation: 'ND' },
  { value: 'Ohio', label: 'Ohio', abbreviation: 'OH' },
  { value: 'Oklahoma', label: 'Oklahoma', abbreviation: 'OK' },
  { value: 'Oregon', label: 'Oregon', abbreviation: 'OR' },
  { value: 'Pennsylvania', label: 'Pennsylvania', abbreviation: 'PA' },
  { value: 'Rhode Island', label: 'Rhode Island', abbreviation: 'RI' },
  { value: 'South Carolina', label: 'South Carolina', abbreviation: 'SC' },
  { value: 'South Dakota', label: 'South Dakota', abbreviation: 'SD' },
  { value: 'Tennessee', label: 'Tennessee', abbreviation: 'TN' },
  { value: 'Texas', label: 'Texas', abbreviation: 'TX' },
  { value: 'Utah', label: 'Utah', abbreviation: 'UT' },
  { value: 'Vermont', label: 'Vermont', abbreviation: 'VT' },
  { value: 'Virginia', label: 'Virginia', abbreviation: 'VA' },
  { value: 'Washington', label: 'Washington', abbreviation: 'WA' },
  { value: 'West Virginia', label: 'West Virginia', abbreviation: 'WV' },
  { value: 'Wisconsin', label: 'Wisconsin', abbreviation: 'WI' },
  { value: 'Wyoming', label: 'Wyoming', abbreviation: 'WY' },
];
